var Child = require('child');
var UserList = require('userlist');


var Conversation = Child.extend({
    away: null,
    initialize: function (data, options) {
        this.connection = options.connection;
        this.recipient = this.connection.makeUserFromTarget(this.id, {
            nick: this.getName()
        });
        Child.prototype.initialize.apply(this, arguments);
        if (this.isSelf()) {
            this.members = new UserList(this.getUser());
        } else {
            this.members = new UserList([
                this.recipient,
                this.getUser()
            ]);
        }
        if (this.connection.isInitialized()) {
            this.once('selectedChange', this.onSelectedChange, this);
        }
    },
    onSelectedChange: function () {
        if (this.isSelected()) {
            var props = this.connection.findUserProps(this.getName());
            if (props) {
                this.setRecipientProps(props);
            }
        }
    },
    idNamespace: function () {
        return 'messages';
    },
    getType: function () {
        if (this.connection.isSlack()) {
            return 'direct message';
        } else {
            return 'conversation';
        }
    },
    isConversation: function() {
        return true;
    },
    connectionStateChange: function () {
        if (this.connection.isReady()) {
            this.activate();
        } else {
            this.deactivate();
        }
    },
    rename: function (newName, callback) {
        this.post('rename-conversation', {
            name: newName
        }, _.bind(function (response) {
            if (!response.success) {
                this.trigger('renameError', newName, response, callback);
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    deactivate: function () {
        this.setBack();
        Child.prototype.deactivate.call(this);
    },
    setRecipientProps: function (props) {
        // Don't override an away message we might already have
        var conversationAway = this.getAway();
        if (
            (conversationAway && props.away) ||
            !('away' in props)
        ) {
            props.away = conversationAway;
        }
        this.recipient.set({
            realname: props.realname || this.recipient.getRealname(),
            ircserver: props.ircserver || this.recipient.get('ircserver'),
            user: props.user || this.recipient.get('user'),
            usermask: props.usermask || this.recipient.get('usermask'),
            userhost: props.userhost || this.recipient.get('userhost'),
            ident_prefix: props.ident_prefix || this.recipient.get('ident_prefix'),
            away: props.away,
            // These can be validly empty, check for existence in object
            account: 'account' in props ? props.account : this.recipient.get('account'),
            avatar: 'avatar' in props ? props.avatar : this.recipient.get('avatar'),
            avatar_url: 'avatar_url' in props ? props.avatar_url : this.recipient.get('avatar_url'),
            display_name: 'display_name' in props ? props.display_name : this.recipient.get('display_name'),
            bot_url: 'bot_url' in props ? props.bot_url : this.recipient.get('bot_url')
        });
        this.trigger('recipientChange');
    },
    messageHandlers: $.extend({}, Child.prototype.messageHandlers, {
        rename_conversation: function (message) {
            var newName = message.new_name;
            this.set({name: newName});
            if (this.isSelected()) {
                this.connection.urlChange();
            }
            this.recipient.set({nick: newName});
        },
        user_chghost: function (message) {
            this.recipient.set({
                user: message.from_name,
                userhost: message.from_host,
                usermask: message.hostmask
            });
        }
    }),
    initializedMessageHandlers: $.extend({}, Child.prototype.initializedMessageHandlers, {
        quit: function (message) {
            this.trigger('resetLookup', this);
        }
    }),
    getRecipient: function () {
        return this.recipient;
    },
    isNickserv: function () {
        return this.getName().toLowerCase() == 'nickserv';
    },
    isSelf: function () {
        return this.recipient.getName() == this.getUser().getName();
    },
    isIgnored: function (options) {
        return this.recipient.isIgnored(options);
    },
    getTitle: function () {
        if (this.isNickserv()) {
            return 'NickServ';
        } else {
            var label;
            if (this.connection.isSlack()) {
                label = 'Direct message';
            } else {
                label = 'Conversation';
            }

            var displayName = this.getDisambiguatedDisplayName();
            return label + ' with ' + displayName;
        }
    },
    getName: function () {
        return this.recipient ? this.recipient.getName() : Child.prototype.getName.call(this);
    },
    getDisplayName: function () {
        return this.recipient.getDisplayName();
    },
    getSlackUrl: function () {
        return this.connection.getSlackBaseUrl() + 'messages/@' + this.normalise() + '/details/';
    },
    setAway: function (value) {
        if (value === undefined) {
            value = true;
        }
        this.recipient.set('away', value);
    },
    setBack: function () {
        this.setAway(false);
    },
    isAway: function () {
        return !!this.getAway();
    },
    getAway: function () {
        return this.recipient.getAway();
    },
    getAccount: function () {
        var account = this.recipient.get('account');
        if (account && account != '*') {
            return account;
        } else {
            return null;
        }
    },
    // Ignore global setting
    isTrackingUnread: function () {
        return !this.getPref('disableTrackUnread');
    },
    setTrackingUnreadPref: function (enable) {
        this.setPref('disableTrackUnread', !enable);
    }
});


module.exports = Conversation;



//////////////////
// WEBPACK FOOTER
// ./app/src/model/conversation.js
// module id = sCU/
// module chunks = 1